module.exports = __webpack_public_path__ + "files/bc84c984f9b43c06c19690c11f255a7d.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/symbols-2.png
// module id = 528
// module chunks = 76